/*
$(window).scroll(function(){
  var sticky = $('.header'),
      scroll = $(window).scrollTop();

  if (scroll >= 50) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});
*/

$(document).ready(function() {

  $('#top-bar-mobile .subscription-btn').click(function(){
    $('#subscription-form').slideToggle('slow')
    $('.subscription-btn i').toggleClass('fa-angle-up')
  });

  $('#find-in-store-btn').click(function(){ 
    var popupBlock = $('#'+$(this).data('popup'));
    popupBlock.addClass('active')
    .find('.fade-out').click(function(){
      popupBlock.css('opacity','0').find('.popup-content').css('margin-top','350px');        
      setTimeout(function(){
        $('.popup').removeClass('active');
        popupBlock.css('opacity','').find('.popup-content').css('margin-top','');
      }, 600);
    });
  });

});  
